import { RepeatRenderManager } from './RepeatRenderManager';

export const RepeatRenderModule = {
  __init__: ['repeatRenderManager'],
  repeatRenderManager: ['type', RepeatRenderManager],
};

export { RepeatRenderManager };
